import { render, staticRenderFns } from "./PendingView.vue?vue&type=template&id=5cc2d29b&scoped=true"
import script from "./PendingView.vue?vue&type=script&lang=js"
export * from "./PendingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc2d29b",
  null
  
)

export default component.exports